<template>
  <span>{{ tweeningValue }}</span>
</template>

<script>
import TWEEN from '@tweenjs/tween.js';

export default {
  name: 'animated-value',
  props: {
    value: {
      type: Number,
      required: true,
    },
    isFloat: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tweeningValue: 0,
    };
  },
  watch: {
    value(newValue, oldValue) {
      this.tween(oldValue, newValue);
    },
  },
  mounted() {
    this.tween(0, this.value);
  },
  methods: {
    tween(startValue, endValue) {
      const vm = this;
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate);
        }
      }

      new TWEEN.Tween({ tweeningValue: startValue })
        .to({ tweeningValue: endValue }, 300)
        .easing(TWEEN.Easing.Sinusoidal.Out)
        .onUpdate((object) => {
          if (this.isFloat) {
            vm.tweeningValue = object.tweeningValue.toFixed(2);
          } else {
            vm.tweeningValue = Math.round(object.tweeningValue);
          }
        })
        .start();

      animate();
    },
  },
};
</script>
